export const getGroupUserRoles = async () => {
  try {
    const response = { participants: [] };

    if (response && response.participants && response.participants.length > 0) {
      return response.participants;
    }
  } catch (error) {
    return [];
  }

  return [];
};
